<template>
    <div class="pantalla">
        <!--            <h1 v-if="!show">Bienvenido</h1>-->
        <div class="row">
            <span style="display: inline"><h3>Búsqueda de comprobantes de pago de empleados</h3></span>
            <hr class="red" style="margin-bottom: 0">

            <div class="col-md-3"/>
            <form v-on:submit.prevent="iniciaRecibos()" class="form-horizontal col-md-6" role="form">

                <!-- modal para la carga -->
                <loading :active.sync="isLoading" color="#9D2449" background-color="#CCCCCC" />
                
                <center>
                    <h3>Criterios de búsqueda</h3>
                    <div v-if=" role_logged !== null && role_logged.includes('BusqRecibos') " class="form-group">
                        
                            <label>
                                <input type="radio" name="radio-01" value="01" v-model="el_radio" @change="setInput()"> Id Empleado
                            </label>
                            <label style="margin-left: 15px">
                                <input type="radio" name="radio-01" value="02" v-model="el_radio" @change="setInput()"> RFC Empleado
                            </label>
                            <input class="form-control" id="rfc" type="text" value="ROCA950222HD3" v-model="el_input" v-mask="mask" v-uppercase @change="setSelect()"
                                required :placeholder="placeHolder">
                    
                    </div>
                    <div v-else>
                        <h5>RFC: {{rfcEmp}}</h5>
                    </div>
                 </center>
                <div class="form-group">
                    <label class="col-sm-2 control-label" for="email-03">Año:</label>
                    <div class="col-sm-3">
                        <select class="form-control" v-on:change="setQuincena($event.target.value)" v-model="el_anio" style="min-width:140px">
                            <option disabled value="" selected>Seleccionar</option>
                            <option :key="anioOption +1" v-for="anioOption in anios" v-bind:value="anioOption"> {{ anioOption}}</option>
                        </select>
                    </div>
                    <label class="col-sm-3 control-label" for="email-03">Quincena:</label>
                    <div class="col-sm-3">
                        <select class="form-control" v-model="la_quincena" style="min-width:150px">
                            <option value="" selected>Seleccionar</option>
                            <option :key="option +1" v-for="option in quincenas" v-bind:value="option"> {{ option}}</option>
                        </select>
                    </div>
                </div>
                <div class="text-center">
                    <!-- Botón de error -->
                    <button type="button" class="btn btn-danger" style="margin: 5px" v-on:click="clean">Limpiar</button>

                    <!-- Botón primario -->
                    <button type="submit" class="btn btn-primary" style="margin: 5px">Buscar
                    </button>
                </div>
            </form>
            <div class="col-md-3"/>
        </div>

        <div class="row" style="margin-bottom: 30px" v-if="show">
            <h3>Comprobantes de pago encontrados</h3>
            <hr class="red" style="margin-bottom: 0">
            <br>
            <div class="table-responsive">
                <table class="table table-striped" style="margin-bottom: 20px">
                    <thead>
                    <tr>
                        <th class="text-center">Número de pago</th>
                        <th class="text-center">Fecha de pago</th>
                        <th class="text-center">Periodo de pago</th>
                        <th class="text-center">Bruto</th>
                        <th class="text-center">Fecha de emisión</th>
                        <th class="text-center">PDF</th>
                        <th class="text-center">XML</th>
                    </tr>
                    </thead>
                    <tbody v-if="recibos != ''">
                        <tr v-for="rec in recibos" v-bind:key="rec.cUUID">
                            <td class="text-center">{{rec.numeroPago}}</td>
                            <td class="text-center">{{rec.fechaPago}}</td>
                            <td class="text-center">{{rec.periodoPago}}</td>
                            <td class="text-center">{{rec.dTotalPercepciones}}</td>
                            <td class="text-center">{{rec.tsFechaTimbrado}}</td>
                            <td class="text-center"> <!--PDF -->

                            <a v-if=" isAdmin() && role_logged !== null && role_logged.includes('BusqRecibos') " @click="apagaModal(rec, 'pdf')" href="" data-toggle="modal"
                            data-target="#modalAviso"><span class="glyphicon glyphicon-file"
                                                            aria-hidden="true"></span></a>

                            <a v-else-if=" role_logged !== null && role_logged.includes('BusqRecibos')"  @click ="descargaRecibos(rec.cUUID, null, 'pdf')"><span class="glyphicon glyphicon-file"
                                                                                    aria-hidden="true"></span></a>

                            <a v-else-if=" role_logged !== null && !role_logged.includes('BusqRecibos') " @click="apagaModal(rec, 'pdf')" href="" data-toggle="modal"
                            data-target="#modalAviso"><span class="glyphicon glyphicon-file"
                                                            aria-hidden="true"></span></a>

                            <a v-else @click ="descargaRecibos(rec.cUUID, null, 'pdf')"><span class="glyphicon glyphicon-file"
                                                                                    aria-hidden="true"></span></a>
                            </td>
                            <td class="text-center"><!--XML-->
                            
                                <a v-if=" role_logged !== null && role_logged.includes('BusqRecibos') && isAdmin() " @click="apagaModal(rec, 'xml')" href="" data-toggle="modal"
                                data-target="#modalAviso">
                            
                                    <span class="glyphicon glyphicon-file"
                                                            aria-hidden="true"></span></a>

                                <a v-else-if=" role_logged !== null && !role_logged.includes('BusqRecibos') " @click="apagaModal(rec, 'xml')" href="" data-toggle="modal"
                                data-target="#modalAviso">
                            
                                    <span class="glyphicon glyphicon-file"
                                                            aria-hidden="true"></span></a>

                                <a v-else @click="descargaRecibos(rec.cUUID, null, 'xml')">
                                    <span class="glyphicon glyphicon-file" aria-hidden="true"></span>
                                </a>
                            </td>
                        </tr>
                </tbody>
                <tbody v-else>
                        <tr><td colspan="8">No se encontraron recibos</td></tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="modal fade" id="modalAviso" tabindex="-1" role="dialog" aria-labelledby="modalAvisoLabel">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Aviso de Privacidad para el uso del <br> Portal de Autoservicio de
                            trabajadores de la SEDATU.</h4>
                    </div>
                    <div class="modal-body text-justify" style="font-size: 13px" v-html="avisoPrivacidad">
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" data-dismiss="modal" @click="descargaRecibos(cuuid, new Date(), null)" >Aceptar</button>
                        <button type="button" class="btn btn-primary" data-dismiss="modal" >Cancelar</button>
                    </div>
                </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
        </div><!-- /.modal -->
    </div>
</template>

<script>
    import axios from 'axios';
    import Vue from 'vue';

    var idUsuario = localStorage.getItem('user_id');
    var vRFC = localStorage.getItem('user_rfc');

    export default {
        name: "ProofOfPayment",
        data() {
            return {
                show: false,
                quincenas: [],
                anios: [],
                role_logged: localStorage.getItem('role'),
                el_anio: '',
                la_quincena: '',
                el_input: '',
                el_radio: '01',
                placeHolder: 'Ingrese ID del empleado',
                nomEmp: '',
                idEmp: localStorage.getItem('user_id'),
                rfcEmp: localStorage.getItem('user_rfc'),
                nombreEmleado: localStorage.getItem('name'),
                recibos: [],
                cuuid: '',
                recModal: false,
                mask: "##########",
                isLoading: false,
                tipoRecibo: '',
                avisoPrivacidad: ''
            }
        },
        methods: {

            buscaEjercicios(){
            const urlSer = Vue.prototype.$globalHost + '/buscaEjercicioXUsuario/' + this.idEmp;// + this.idEmpleadoLogueado;
 /*           console.log(urlSer);
            console.log("vRFC: " + this.rfcEmp);
            console.log('Token: ' + localStorage.getItem('token'));
            console.log("role_logged" + this.role_logged);*/
            axios.get(urlSer,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': localStorage.getItem('token')
                }
            })
            .then(response => {
                this.anios = response.data;
                //console.log(this.anios);
                
            })
            .catch(error => {

                this.procesarErrorYdesplegarMensaje(error,
                'Ocurrió un error al obtener la información de los posibles años a seleccionar')
            })
            },

            buscaAvisoPriv(){
                const urlSer = Vue.prototype.$globalHost + '/buscaProperty/AvisoPrivPortalRH'
                axios.get(urlSer,
                {
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': localStorage.getItem('token')
                }
                })
                .then(response => {
                    this.avisoPrivacidad = response.data;
                // console.log(this.avisoPrivacidad);
                })
                .catch(function(error){

                    this.procesarErrorYdesplegarMensaje(error,
                    'Ocurrió un error al obtener la información del aviso de privacidad')
                })
            },

            isAdmin(){

                var iduser = this.idEmp;
                let rfcBusq = this.rfcEmp;
                var isAdm = false;

                
                
                if (this.el_radio == '01') {

                    if (this.el_input != '') {
                        rfcBusq = '';

                        if(iduser == this.el_input){
                            isAdm = true;
                        }else{
                            isAdm = false;
                        }

                       }
                } else if(this.el_radio == '02') {
                    
                    let rdfTmp = this.el_input;
                    if(rfcBusq == rdfTmp.replace(/-/g,"").toUpperCase() ){
                      isAdm = true;
                        }else{
                            isAdm = false;
                        }

                }
                    
                return isAdm;
            },

            buscarRecibos(){

                this.isLoading = true;

                let user = this.idEmp;
                let rfcBusq = this.rfcEmp;
                
                if (this.el_radio == '01') {

                    if (this.el_input != '') {
                        user = this.el_input;
                        rfcBusq = '';
                       }
                } else if(this.el_radio == '02') {
                    rfcBusq = '';
                    
                    if (this.el_input != '') {
                        //console.log('Radio: ' + this.el_radio);
                        rfcBusq = this.el_input;

                        const urlBuscID = Vue.prototype.$globalHost + '/buscaIdUsuarioXrfc/' + rfcBusq.replace(/-/g,"").toUpperCase();
                        

                        axios.get(urlBuscID,
                        {
                            headers: {
                                'Content-Type': 'application/json',
                                'authorization': localStorage.getItem('token')
                            }
                        })
                        .then(response => {
                            user = response.data;
                         }).catch(error => {

                        this.isLoading = false;
                        this.show = false;
                        this.procesarErrorYdesplegarMensaje(error,
                     'Ocurrió un error al buscar la información de los comprobantes de pago')
                    })
                    }
                }

                const urlRecibos = Vue.prototype.$globalHost + '/buscaRecibos';
                   axios.post(urlRecibos,{
                        cRfc            :   rfcBusq.replace(/-/g,"").toUpperCase(),
                        iNumEmpleado    :   user,
                        iEjercicio      :   this.el_anio,
                        dtPeriodo       :   this.la_quincena
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': localStorage.getItem('token')
                    }
                })
                .then(response => {
                    //console.log(response.data);
                    this.recibos = response.data;
                    //console.log(this.recibos);
                    this.show = true;
                    this.isLoading = false;
                }).catch(error => {

                    this.isLoading = false;
                    this.show = false;

					this.procesarErrorYdesplegarMensaje(error,
                    'Ocurrió un error al buscar la información de los comprobantes de pago')
				})
            },

            iniciaRecibos(){
                this.buscaAvisoPriv();
                this.buscarRecibos();
            },

            verModal(tipoUsuario, modal){
                //console.log("tipoUsuario: " + tipoUsuario + " modal: " + modal.aceptaAvisoPriv);
                let mod = modal.aceptaAvisoPriv;
                if(tipoUsuario == 'user' &&  mod){
                    return true
                }else{
                    return false
                }
            },

            descargaRecibos(cuid, fechaAceptacionAviso, tiRec){
                let urlDesc = '';

                var isSafari = null;
                var ua = navigator.userAgent.toLowerCase(); 
                var windowReference = null;

                if (ua.indexOf('safari') != -1) { 
                    if (ua.indexOf('chrome') > -1) {
                        isSafari = 0;
                    } else {
                        isSafari = 1;
                    }
                } else{
                    isSafari = 0; 
                }
                
                if(isSafari > 0){
                    windowReference = window.open();
                }
                   
                if(tiRec != null){
                    this.tipoRecibo = tiRec; 
                }
                if(this.tipoRecibo == 'xml'){
                    urlDesc = Vue.prototype.$globalHost + '/descRecibo';
                }else{
                    urlDesc = Vue.prototype.$globalHost + '/descReciboPdf';
                }
                axios.post(urlDesc,{
                    iejercicio      :   null,//this.el_anio,
                    inumempleado    :   null,//user,
                    cUUID           :   cuid,
                    cRFC            :   null,//rfcBusq,
                    fechaAcepAviso  :   fechaAceptacionAviso
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': localStorage.getItem('token'),
                        'responseType': 'blob'
                    }
                })
                .then(response => {
                    const xmlRec = response.data;
                    //console.log('Nombre de archivo: ' + xmlRec.nomXml);
                    let url = '';
                    if(this.tipoRecibo == 'xml'){
                        url = window.URL.createObjectURL(new Blob([xmlRec.xml]));
                    }else{
                        const file = window.atob(xmlRec.cPdf);
                        var byteNumbers = new Array(file.length);
                        for (var i = 0; i < file.length; i++) {
                           byteNumbers[i] = file.charCodeAt(i);
                        }
                        var byteArray = new Uint8Array(byteNumbers);
                        url = window.URL.createObjectURL(new Blob([byteArray], { type: "application/pdf" }));
                    }
                    var link = null;
                    if(isSafari > 0){
                        link =  windowReference.document.createElement('a');
                    }else{
                        link =  document.createElement('a');
                    }
                   
                    link.href = url;
                    link.setAttribute('download', xmlRec.nomXml); 
                    link.click();
                    this.tipoRecibo = '';
                })
                .catch(error => {

					this.show = false;
					this.procesarErrorYdesplegarMensaje(error,
                    'Ocurrió un error al descargar el comprobante de pago')
				})
            },

            apagaModal(uid, trec){
                //console.log('uid: ' + uid + "  uid.aceptaAvisoPriv  " + uid.aceptaAvisoPriv);
                this.cuuid = uid.cUUID;
                this.tipoRecibo = trec;
                uid.aceptaAvisoPriv = false;
                //console.log('this.cuuid  ' + this.cuuid + '  Tipo:  ' + this.tipoRecibo + " uid.aceptaAvisoPriv: " + uid.aceptaAvisoPriv);
            },

            setUsuario(){
                if (this.el_input != '') {
                    this.idEmp = this.el_input;
                    //console.log('Id de usuario: ' + this.idEmp);
                } else {
                    idUsuario = '';
                }
            },

            setRfc(){
                idUsuario = '';
                
                if (this.el_input != '') {
                    vRFC = this.el_input;

                    const urlBuscID = Vue.prototype.$globalHost + '/buscaIdUsuarioXrfc/' + vRFC.replace(/-/g,"").toUpperCase();
                    //console.log('urlBuscID: ' + urlBuscID);

                    axios.get(urlBuscID,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization': localStorage.getItem('token')
                    }
                    })
                    .then(response => {
                        this.idEmp = response.data;
                        //console.log(this.idEmp);
                
                    })
                    .catch(error => {

                        if (error.response.status === 403) {
                            this.alertaTokenFinalizo();
                        }
                    })

                }
            },
            setInput() {

                this.el_input = '';
                this.el_anio = ''
                this.la_quincena = ''
                this.show = false

                if (this.mask === "##########") {
                    this.mask = "AAAA-######-XXX";
                    this.placeHolder = 'Ingrese RFC del empleado'
                } else {
                    this.mask = "##########";
                    this.placeHolder = 'Ingrese ID del empleado'
                }
            },
            setSelect(){

                idUsuario = '';
                if (this.el_radio == '01') {

                    vRFC = '';
                    if (this.el_input != '') {
                        idUsuario = this.el_input;
                        //console.log('Id de usuario: ' + idUsuario);
                            
                        const urlSer = Vue.prototype.$globalHost + '/buscaEjercicioXUsuario/' + idUsuario;// + this.idEmpleadoLogueado;
                        //console.log(urlSer);
                        //console.log('Token: ' + localStorage.getItem('token'));
                        axios.get(urlSer,
                        {
                            headers: {
                                'Content-Type': 'application/json',
                                'authorization': localStorage.getItem('token')
                            }
                        })
                        .then(response => {
                            this.anios = response.data;
                            //console.log("response.data:  " + response.data);
                            //console.log("Ejercicios:  " + this.anios);
                            
                        })
                        .catch(error => {

                            this.procesarErrorYdesplegarMensaje(error,
                            'Ocurrió un error al obtener la información de los posibles años a seleccionar')
                        })
                    }

                } else if(this.el_radio == '02') {

                    if (this.el_input != '') {
                        //console.log('Radio: ' + this.el_radio);
                        vRFC = this.el_input;

                        const urlBuscID = Vue.prototype.$globalHost + '/buscaIdUsuarioXrfc/' + vRFC.replace(/-/g,"").toUpperCase();
                        //console.log('urlBuscID: ' + urlBuscID);

                        axios.get(urlBuscID,
                        {
                            headers: {
                                'Content-Type': 'application/json',
                                'authorization': localStorage.getItem('token')
                        }
                        })
                        .then(response => {
                            idUsuario = response.data;
                            //console.log("idUsuario rfc: " + idUsuario);
                            
                            if( idUsuario != '' ){
                                const urlSer = Vue.prototype.$globalHost + '/buscaEjercicioXUsuario/' + idUsuario;// + this.idEmpleadoLogueado;
                            //console.log(urlSer);
                            //console.log('Token: ' + localStorage.getItem('token'));
                            axios.get(urlSer,
                            {
                                headers: {
                                    'Content-Type': 'application/json',
                                    'authorization': localStorage.getItem('token')
                                }
                            })
                            .then(response => {
                                this.anios = response.data;
                               //console.log("response.data:  " + response.data);
                                //console.log("Ejercicios:  " + this.anios);
                                
                            })
                            .catch(error => {

                                this.procesarErrorYdesplegarMensaje(error,
                                'Ocurrió un error al obtener la información de los posibles años a seleccionar')
                            })
                            }
                        }).catch(error => {

                            if (error.response.status === 403) {
                                this.alertaTokenFinalizo();
                            }
                        })

                    }
                }
            },

            setQuincena() {
                //console.log(quinc)
            const urlQna = Vue.prototype.$globalHost + '/buscaQnXEjXUs/' + idUsuario + '/' + this.el_anio;
            //console.log('urlQna: ' + urlQna);

            this.la_quincena = '';
            axios.get(urlQna,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': localStorage.getItem('token')
                }
            })
            .then(response => {
                this.quincenas = response.data;
                //console.log(this.quincenas);
                
            })
            .catch(error => {

                this.procesarErrorYdesplegarMensaje(error,
                'Ocurrió un error al obtener la información de las posibles quincenas a seleccionar')
            })

            },

            
            clean() {
                this.el_anio = ''
                this.la_quincena = ''
                this.el_input = ''
                this.show = false
                this.el_radio = '01'
                this.mask = "##########"
                this.placeHolder = 'Ingrese ID del empleado'
            }
        },
        mounted() {

          /*  console.log('Entrando a login');
            axios.post('http://10.33.146.20:8090/PortalRH-0.0.1-SNAPSHOT/login',{
                "usuario": "usuario", 
                "password": "password"
            })
            .then(response => {

                console.log('Entrando a login.....2' + response.headers);

                localStorage.setItem('token',response.headers.authorization);
                this.nomEmp = localStorage.getItem('name');
                this.idEmp = localStorage.getItem('user_id');
                console.log('id de usuario: ' + this.idEmp);
                this.rfcEmp = localStorage.getItem('user_rfc');
                console.log(localStorage);
            })
            .catch(function(error){
                console.log(error);
            })   */

            //axios.post('window.location.origin +/PortalRH-0.0.1-SNAPSHOT/consultaAniosBitacora/7133801',{

            /* Buscar ejercicios por usuario */

            if (this.role_logged !== null && this.role_logged.includes('ProofOfPayment')) {
                idUsuario = this.idEmp;
                const urlSer = Vue.prototype.$globalHost + '/buscaEjercicioXUsuario/' + idUsuario;// + this.idEmpleadoLogueado;
                axios.get(urlSer,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': localStorage.getItem('token')
                    }
                })
                .then(response => {
                    this.anios = response.data;
                    //console.log(this.anios);
                    
                })
                .catch(error => {

                    this.procesarErrorYdesplegarMensaje(error,
                    'Ocurrió un error al obtener la información de los posibles años a seleccionar')
                })
            }
        }
    }
</script>